export enum ChargeStatus {
    aborted = 3,
    // cobranças entre 10 e 99 cancelam imediatamente a assinatura
    failed = 5, // falha no gateway
    declined = 50, // não autorizado
    reversed = 60, // desfeita (geralmente no ato do pagamento (duplicidade?))
    canceled_manual = 70, //cobrança totalmente estornada ou cancelada manualmente
    canceled = 75, //cobrança totalmente estornada ou cancelad
    charged_back = 90, // charge back realizado

    // cobranças entre 100 e 150 não alteram o status
    integration_error = 105,
    unknown = 110,
    dispute = 115, // solicitação de charge back
    refund_pending = 118,
    refunded = 120, // estornado
    // o DOCUMENTO morreu (boleto vencido, QR expirado, cobrança invalidada no gateway) e a dívida
    // continua em aberto. não confundir com cancelada: cancelar é decisão de quem cobra
    expired = 130,
    pending = 135, //aguardando pagamento (pix ou boleto)
    processing = 140, // cobrança está em processo de envio ao gateway
    pre_authorized = 150, // pre autorizado (cartão) // não iremos usar essa realidade

    // cobranças entre 150 e 199 precisam ser avaliadas conforme regras
    scheduled = 175, // cobrança criada (nada ocorreu cobrança ainda)

    // cobranças igual ou acima de 200 sempre manterão a assinatura ativa
    paid_manual = 220, // baixa manual pelo usuário. uma vez nesse status, não é mais atualizado pela api.
    paid = 250, // pago
} // status finais:  canceled / declined / reversed / paid

export enum PaymentMethods {
    'credit' = 'credit',
    'pix' = 'pix',
    'bankslip' = 'bankslip',
}

// Rótulo de cada meio de pagamento. Fonte única: as telas montam as opções a partir do que a api
// informa em gateway.gatewayPaymentMethods e buscam o texto aqui, em vez de listar meio a meio.
// Assim um meio novo aparece sozinho nas telas assim que o adapter do gateway passar a aceitá-lo.
export enum PaymentMethodsFriendly {
    'credit' = 'Cartão de crédito',
    'pix' = 'Pix',
    'bankslip' = 'Boleto',
}

export enum ChargeStatusFriendly {
    aborted = 'anulado',
    // cobranças entre 10 e 99 cancelam imediatamente a assinatura
    failed = 'erro', // falha no gateway
    declined = 'negado', // não autorizado
    reversed = 'revertido', // desfeita (geralmente no ato do pagamento (duplicidade?))
    canceled_manual = 'cancelado manualmente', //cobrança totalmente estornada ou cancelada manualmente
    canceled = 'cancelado', //cobrança totalmente estornada ou cancelad
    charged_back = 'charge back', // charge back realizado

    // cobranças entre 100 e 150 não alteram o status
    integration_error = 'erro de integração',
    unknown = 'status desconhecido',
    dispute = 'em disputa', // solicitação de charge back
    refund_pending = 'estorno em andamento',
    refunded = 'estornado', // estornado
    // a parcela segue em aberto: o que venceu foi o documento, e basta emitir outro
    expired = 'documento vencido',
    pending = 'pendente', //aguardando pagamento (pix ou boleto)
    processing = 'processando', // cobrança está em processo de envio ao gateway
    pre_authorized = 'pré-autorizado', // pre autorizado (cartão) // não iremos usar essa realidade

    // cobranças entre 150 e 199 precisam ser avaliadas conforme regras
    scheduled = 'agendado', // cobrança criada (nada ocorreu cobrança ainda)

    // cobranças igual ou acima de 200 sempre manterão a assinatura ativa
    paid_manual = 'pago manualmente', // baixa manual pelo usuário. uma vez nesse status, não é mais atualizado pela api.
    paid = 'pago', // pago
} // status finais:  canceled / declined / reversed / paid
